var couTurbolinks, startSpinner, stopSpinner;

couTurbolinks = function () {
  $(document).on("page:fetch", startSpinner);
  return $(document).on("page:receive", stopSpinner);
};

startSpinner = function () {
  return $("#main").addClass("loading");
};

stopSpinner = function () {
  return $("#main").removeClass("loading");
};

$(document).on("page:load", couTurbolinks);

$(function () {
  return couTurbolinks();
});

// ---
// generated by coffee-script 1.9.2
